/**
 * The "Create Job" link on What's Due (Compliance).
 *
 * The New Job form (`pages/jobs/form.tsx`) reads `customerId` and `siteId`
 * from the URL. This button used to send `customer_id` / `site_id`, so the
 * form opened empty and the office had to find the customer and site again.
 * Keep the names camelCase, the same as every other New Job link.
 */
export interface CreateJobSource {
    customer_id: string | null;
    site_id: string | null;
    trade_id: string | null;
    asset_id: string | null;
}

export function complianceNewJobHref(asset: CreateJobSource): string {
    const params = new URLSearchParams();
    if (asset.customer_id) params.set("customerId", String(asset.customer_id));
    if (asset.site_id) params.set("siteId", String(asset.site_id));
    if (asset.trade_id) params.set("tradeId", String(asset.trade_id));
    if (asset.asset_id) params.set("assetId", String(asset.asset_id));
    const qs = params.toString();
    return qs ? `/jobs/new?${qs}` : "/jobs/new";
}
